import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars-2";
import { useFilteredSidebarData } from "../../data/json/sidebarData";
import ImageWithBasePath from "../imageWithBasePath";
import { useDispatch, useSelector } from "react-redux";
import { setExpandMenu, setMobileSidebar } from "../../data/redux/commonSlice";
import { useUser } from '../../../context/userContext';
import { apiService } from '../../../services/api';
import { all_routes } from '../../../feature-module/router/all_routes';
import { usePermissions } from '../../../hooks/usePermissions';

const Sidebar = () => {
  const Location = useLocation();
  const expandMenu = useSelector((state: any) => state.expandMenu);
  const dispatch = useDispatch();
  const { userData } = useUser(); // Usar o contexto em vez do estado local
  const sidebarData = useFilteredSidebarData(); // Usar dados filtrados por permissão

  const { hasPermission } = usePermissions();
  const podeAprovarPendente = hasPermission('AUTORIZACOES', 'APROVAR_PENDENTE');

  const [subOpen, setSubopen] = useState<any>('');
  const [subsidebar, setSubsidebar] = useState("");
  const [comprasCount, setComprasCount] = useState(0);
  const [pendentesCount, setPendentesCount] = useState(0);

  const toggleSidebar = (title: any) => {
    localStorage.setItem('menuOpened', title)
    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
  };

  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };

  const toggle = () => {
    dispatch(setExpandMenu(true));
  };

  const toggle2 = () => {
    dispatch(setExpandMenu(false));
  };

  // Helper para detectar se está em mobile
  const isMobile = () => {
    return window.matchMedia('(max-width: 991px)').matches;
  };

  // Fecha o menu apenas se estiver em mobile
  const closeMenuOnMobile = () => {
    if (isMobile()) {
      dispatch(setMobileSidebar(false));
    }
  };

  // Função para obter a URL da imagem de perfil
  const getProfileImageUrl = () => {
    if (userData?.foto_perfil_url) {
      return userData.foto_perfil_url;
    }
    return "assets/img/profiles/avatar-14.jpg"; // Imagem padrão
  };
 
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    apiService.getMinhasAutorizacoesCount().then(setComprasCount).catch(() => {});
    if (podeAprovarPendente) {
      apiService.getPendentesAprovacaoCount().then(setPendentesCount).catch(() => {});
    }

    const handleEmpenhoAtualizado = () => {
      apiService.getMinhasAutorizacoesCount().then(setComprasCount).catch(() => {});
      if (podeAprovarPendente) {
        apiService.getPendentesAprovacaoCount().then(setPendentesCount).catch(() => {});
      }
    };

    window.addEventListener('empenho-status-changed', handleEmpenhoAtualizado);
    return () => window.removeEventListener('empenho-status-changed', handleEmpenhoAtualizado);
  }, []);

  useEffect(() => {
    setSubopen(localStorage.getItem('menuOpened'))
    
    // Select all 'submenu' elements
    const submenus = document.querySelectorAll('.submenu')
    // Loop through each 'submenu'
    submenus.forEach((submenu) => {
      // Find all 'li' elements within the 'submenu'
      const listItems = submenu.querySelectorAll('li')
      submenu.classList.remove('active')
      // Check if any 'li' has the 'active' class
      listItems.forEach((item) => {
        if (item.classList.contains('active')) {
          // Add 'active' class to the 'submenu'
          submenu.classList.add('active')
          return
        }
      })
    })
    
  }, [Location.pathname])
 
  return (
    <>
      <div
        className="sidebar"
        id="sidebar"
        onMouseEnter={toggle}
        onMouseLeave={toggle2}
      >
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                <li className="clinicdropdown theme">
                  <Link to="/meus-dados" onClick={closeMenuOnMobile}>
                    <ImageWithBasePath
                      src={getProfileImageUrl()}
                      className="img-fluid"
                      alt="Profile"
                      style={{
                        width: '40px',
                        height: '40px',
                        objectFit: 'cover',
                        borderRadius: '50%'
                      }}
                    />
                    <div className="user-names">
                      <h5>{userData?.name || 'Usuário'}</h5>
                      <h6>{userData?.cargo || 'Cargo não informado'}</h6>
                    </div>
                  </Link>
                </li>
              </ul>

              {/* Resto do código do sidebar permanece igual */}
              <ul>
                {sidebarData?.map((mainLabel, index) => (
                  <li className="clinicdropdown" key={index}>
                    <h6 className="submenu-hdr">{mainLabel?.label}</h6>
                    <ul>
                      {mainLabel?.submenuItems?.map((title: any, i) => {
                        let link_array: any = [];
                        if ("submenuItems" in title) {
                          title.submenuItems?.forEach((link: any) => {
                            link_array.push(link?.link);
                            if (link?.submenu && "submenuItems" in link) {
                              link.submenuItems?.forEach((item: any) => {
                                link_array.push(item?.link);
                              });
                            }
                          });
                        }
                        title.links = link_array;

                        return (
                          <li className="submenu" key={title.label}>
                            <Link
                              to={title?.submenu ? "#" : title?.link}
                              onClick={() => {
                                toggleSidebar(title?.label);
                                if (!title?.submenu) closeMenuOnMobile();
                              }}
                              className={`${
                                subOpen === title?.label ? "subdrop" : ""
                              } ${
                                title?.links?.includes(Location.pathname)
                                  ? "active"
                                  : ""
                              } ${
                                title?.submenuItems
                                        ?.map((link: any) => link?.link)
                                        .includes(Location.pathname) ||
                                        title?.link === Location.pathname
                                        ? "active"
                                        : "" || 
                                        title?.subLink1 === Location.pathname
                                        ? "active"
                                        : "" || 
                                        title?.subLink2 === Location.pathname
                                        ? "active"
                                        : "" || 
                                        title?.subLink3 === Location.pathname
                                        ? "active"
                                        : "" || 
                                        title?.subLink4 === Location.pathname
                                        ? "active"
                                        : ""
                              }`}
                            >
                              <i className={title.icon}></i>
                              <span>{title?.label}</span>
                              {title?.link === all_routes.Empenhos && comprasCount > 0 && (
                                <span style={{
                                  background: '#fd7e14',
                                  color: '#fff',
                                  borderRadius: '50%',
                                  minWidth: '20px',
                                  height: '20px',
                                  padding: '0 5px',
                                  fontSize: '12px',
                                  fontWeight: '700',
                                  marginLeft: 'auto',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  flexShrink: 0,
                                }}>
                                  {comprasCount}
                                </span>
                              )}
                              {title?.link === all_routes.Empenhos && podeAprovarPendente && pendentesCount > 0 && (
                                <span style={{
                                  background: '#dc3545',
                                  color: '#fff',
                                  borderRadius: '50%',
                                  minWidth: '20px',
                                  height: '20px',
                                  padding: '0 5px',
                                  fontSize: '12px',
                                  fontWeight: '700',
                                  marginLeft: comprasCount > 0 ? '4px' : 'auto',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  flexShrink: 0,
                                }}>
                                  {pendentesCount}
                                </span>
                              )}
                              <span
                                className={title?.submenu ? "menu-arrow" : ""}
                              />
                            </Link>
                            <ul
                              style={{
                                display:
                                  subOpen === title?.label ? "block" : "none",
                              }}
                            >
                              {title?.submenuItems?.map((item: any) => (
                                <li
                                  className="submenu submenu-two"
                                  key={item.label}
                                >
                                  <Link
                                    to={item?.link}
                                    className={
                                      `${item?.submenuItems
                                        ?.map((link: any) => link?.link)
                                        .includes(Location.pathname) ||
                                      item?.link === Location.pathname
                                        ? "active subdrop"
                                        : ""} `
                                    }
                                    onClick={() => {
                                      toggleSubsidebar(item?.label);
                                      if (!item?.submenu) closeMenuOnMobile();
                                    }}
                                  >
                                    {item?.label}
                                    <span
                                      className={
                                        item?.submenu ? "menu-arrow" : ""
                                      }
                                    />
                                  </Link>
                                  <ul
                                    style={{
                                      display:
                                        subsidebar === item?.label
                                          ? "block"
                                          : "none",
                                    }}
                                  >
                                    {item?.submenuItems?.map(
                                      (items: any) => (
                                        <li key={items.label}>
                                          <Link
                                            to={items?.link}
                                            onClick={closeMenuOnMobile}
                                            className={`${
                                              subsidebar === items?.label
                                                ? "submenu-two subdrop"
                                                : "submenu-two"
                                            } ${
                                              items?.submenuItems
                                                ?.map((link: any) => link.link)
                                                .includes(Location.pathname) ||
                                              items?.link === Location.pathname
                                                ? "active"
                                                : ""
                                            }`}
                                          >
                                            {items?.label}
                                          </Link>
                                        </li>
                                      )
                                    )}
                                  </ul>
                                </li>
                              ))}
                            </ul>
                          </li>
                        );
                      })}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};

export default Sidebar;